import { ALL_GRADES } from "../../lib/grades";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

type GradeSelectProps = {
  id?: string;
  value: string | undefined;
  onChange: (value: string) => void;
};

// Radix SelectItem can't take value="", so an empty/unset grade is represented
// by this sentinel internally and translated back to "" at the onChange boundary.
const UNSET_VALUE = "__unset__";

export const GradeSelect = ({ id, value, onChange }: GradeSelectProps) => (
  <Select
    value={value || UNSET_VALUE}
    onValueChange={(v) => onChange(v === UNSET_VALUE ? "" : v)}
  >
    <SelectTrigger id={id}>
      <SelectValue placeholder="Select grade" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={UNSET_VALUE}>Not set</SelectItem>
      <SelectSeparator />
      {ALL_GRADES.map((grade) => (
        <SelectItem key={grade} value={grade}>
          {grade === "HS" ? "High School" : `Grade ${grade}`}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
